import React from 'react'
import Chart from "react-apexcharts";

export default function BarChart(props) {
	const chartData = {     
		series: [{
		  	name: '사용자 ',
		//   data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
			data: props.data,
		}],
		options: {
			chart: {
				toolbar: {
					show: false
				},
				type: 'bar',
				height: 350
			},
			title: {
				text: props.title,
				align: 'center'
			},
			plotOptions: {
				bar: {
					borderRadius: 10,
					horizontal: false,
					columnWidth: '55%',
					endingShape: 'rounded',
					distributed: true,
				},
			},
			dataLabels: {
				enabled: false
			},
			legend: {
				show: false
			},
			stroke: {
				show: true,
				width: 1,
				colors: ['transparent']
			},
			xaxis: {
				labels: {
					style: {
						fontSize: '10px',
					},
					rotate: -45,
				},
				categories: props.categories,
			},
			yaxis: {
				title: {
					// text: '명 (thousands)'
				}
			},
			fill: {
				opacity: 1
			},
			tooltip: {
				y: {
					formatter: function (val) {
						return val + " 명"
					}
				}
			}
		},
	};


	return (
		<div id="chart">
			<Chart options={chartData.options} series={chartData.series} type="bar" height={270} />
		</div>
	)
}
